import { signal, Signal, WritableSignal } from "@angular/core";

export abstract class AbstractNavItem {  
}

export abstract class TypedNavItem<T> extends AbstractNavItem {
  public items: Signal<T[]> = signal([]);
}

export interface IMenu {
  subMenu?: WritableSignal<IMenu|null>;
  items?: Signal<AbstractNavItem[]>;
  toggleSubMenu?(navItem: AbstractNavItem): void;        
}
